export default {
  allProducts(state) {
    return state.products;
  },
  selectedProduct(state) {
    return state.selectedProduct;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/product/getters.js